
import { defineComponent, onBeforeMount, PropType } from 'vue'

type ViewValue = 'list' | 'table'

export default defineComponent({
    props: {
        value: {
            type: String as PropType<ViewValue>,
            default: 'table'
        }
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const initializeValue = () => {
            const savedView = localStorage.getItem('bpms-view-manager-value')

            if (savedView) {
                emit('update:value', savedView)
            }
        }

        const changeView = (view: ViewValue) => {
            if (view === props.value) {
                return
            }

            localStorage.setItem('bpms-view-manager-value', view)
            emit('update:value', view)
        }

        onBeforeMount(initializeValue)

        return {
            changeView
        }
    }
})
